import { Module } from '@nestjs/common';
import { DesignationActionService } from './designation-action.service';
import { DesignationActionController } from './designation-action.controller';
import { TypeOrmModule } from '@nestjs/typeorm';
import { DesignationActionAdapter } from './dto/designation-action.adapter';
import { DesignationAction } from './designation-action.entity';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { DepartmentService, EmployeeService } from '@gtpl/shared-services/masters';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
@Module({
  imports: [
    TypeOrmModule.forFeature([DesignationAction]),
  ],
  controllers: [DesignationActionController],
  providers: [DesignationActionService, DesignationActionAdapter,EmployeeService, ApplicationExceptionHandler,DepartmentService,WhatsappBroadCastService],
  exports: [DesignationActionService]
})
export class DesignationActionModule {}



